<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="EligibilityCriteriaForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class="row align-items-center">
                                            <div class="col-md-4 prpl">
                                                <div class="d-flex align-items-center">
                                                    <img alt="Logo" src="../../assets/img/attendance.png"
                                                        class="mh-45px pb-2">
                                                    <p class="mb-1">
                                                        <span class="main-content-label"><b> Exam Form Eligibility
                                                                Criteria</b></span><br>
                                                        <span class="text-muted card-sub-title mb-0">Eligibility
                                                            Criteria</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <hr class="mt-2"> -->
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select [disabled]="isdisabled" #select22
                                                            placeholder="Session" class="colorblack"
                                                            formControlName="SessionID">
                                                            <mat-select-filter *ngIf="select22.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)=" SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  SessionFilterList"
                                                                (click)="selectSessionID(item.SnNo)"
                                                                [value]="item.SnNo">
                                                                {{item.SnNo}} - {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="EligibilityCriteriaForm.controls['SessionID'].touched && EligibilityCriteriaForm.controls['SessionID'].errors?.required">
                                                            Session is Required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>{{'header.faculty-data.titleList.Faculty'| translate
                                                        }}</mat-label>
                                                    <mat-select [disabled]="isdisabled" #select33
                                                        placeholder="CoFcCode" class="colorblack"
                                                        formControlName="CoFcCode"
                                                        >
                                                        <mat-select-filter *ngIf="select33.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'FcDesc'"
                                                            [array]="fcCodeList"
                                                            (filteredReturn)="filteredListFcCode =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListFcCode"
                                                            [value]="item.FcCode"  (click)="getCourseData(item.FcCode)">
                                                            {{item.FcCode}} - {{item.FcDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="EligibilityCriteriaForm.controls['CoFcCode']?.touched && EligibilityCriteriaForm.controls['CoFcCode'].errors?.required">
                                                         Faculty is Required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack" 
                                                            formControlName="course">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredCourseList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCourseList"
                                                                [value]="item.CoCode" (click)="getExamList(item.CoCode)"> 
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="EligibilityCriteriaForm.get('course')?.hasError('required') &&
      (EligibilityCriteriaForm.get('course')?.touched ||
       EligibilityCriteriaForm.get('course')?.dirty)">
                                                            Course is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Exam
                                                        </mat-label>
                                                        <mat-select #select2398 placeholder="Exam" 
                                                            formControlName="EmId"
                                                            (selectionChange)="getCriteria($event)">
                                                            <mat-select-filter *ngIf="select2398.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="examList"
                                                                (filteredReturn)="filteredListExam =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.EmId">
                                                                {{item.EmCoCode}}-{{item.EmName}}
                                                            </mat-option>

                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="EligibilityCriteriaForm.get('EmId').hasError('required')">
                                                            Exam is required
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="card criteria-card">
                                                <div class="card-body">
                                                    <table class="table criteria-table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Criteria</th>
                                                                <th>Enabled</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>Attendance</td>
                                                                <td>
                                                                    <mat-checkbox
                                                                        formControlName="Attendence"></mat-checkbox>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>IA Marks</td>
                                                                <td>
                                                                    <mat-checkbox
                                                                        formControlName="IA_Marks"></mat-checkbox>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Elective Subject</td>
                                                                <td>
                                                                    <mat-checkbox
                                                                        formControlName="Elective"></mat-checkbox>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div class="card-footer text-end">
                                                    <button type="button" class="btn btn-primary"
                                                        (click)="saveCriteria()" [disabled]="isCriteriaSaved">
                                                        <i class="fa fa-save"></i>
                                                        Save
                                                    </button>

                                                    <button type="button" class="btn btn-outline-primary me-2"
                                                        (click)="cancelSelection()">
                                                        <i class="fa fa-times"></i>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>